document.addEventListener("DOMContentLoaded", function () {
    const accordions = document.querySelectorAll("details.faq-item");

    accordions.forEach(detail => {
      const summary = detail.querySelector("summary");
      const content = detail.querySelector(".faq-content");

      content.style.overflow = "hidden";
      content.style.transition = "max-height 0.3s ease";

      if (detail.hasAttribute("open")) {
        content.style.maxHeight = content.scrollHeight + "px";
      }

      summary.addEventListener("click", (e) => {
        e.preventDefault();

        if (detail.hasAttribute("open")) {
          content.style.maxHeight = content.scrollHeight + "px";
          requestAnimationFrame(() => {
            content.style.maxHeight = "0px";
          });

          content.addEventListener("transitionend", function handler() {
            detail.removeAttribute("open");
            content.removeEventListener("transitionend", handler);
          });
        } else {
          detail.setAttribute("open", "true");
          content.style.maxHeight = "0px";
          requestAnimationFrame(() => {
            content.style.maxHeight = content.scrollHeight + "px";
          });
        }
      });
    });
  });